export const RESET_LOADING = 'RESET_LOADING';

export const SET_TICKETS = 'SET_TICKETS';
export const SET_CONVERSATION = 'SET_CONVERSATION';

export const SET_LOADING = 'SET_LOADING';